import BaseModelAPI from '../BaseModelAPI';

export default class JobConfigurationList extends BaseModelAPI {

	static entity = 'jobconfigurationlist'
	static entityName = 'jobconfiguration';

	constructor() {
		this.pageIndex = 0;
		this.pageSize = 0;
		this.pageCount = 0;
		this.dataCount = 0;
	}
}
